import {defineStore} from "pinia/dist/pinia";
import jwt_decode from "jwt-decode";

export const useUserStore = defineStore('UserStore', {
    state() {
        return {
            userState: null
        }
    },
    getters: {
        user() {
            if(this.userState != null && this.userState.token != null ){
                return new Date(jwt_decode(this.userState.token).exp) < Date.now()/1000 ? null : this.userState
            }
            return this.userState
        },
    },
    actions: {
        setUser(user) { this.userState = user },
        logout() {
            this.$reset()
        }
    },
    persist: {
        storage: sessionStorage
    }
})